import type { GenericSearchFilter } from '../api/use-generic-search-with-filter'

import FacelessBizSearchResultItemSkeleton from './faceless-biz-search-result-item-skeleton'
import UserSearchResultItemSkeleton from './user-search-result-item-skeleton'

type GenericSearchResultsViewSkeletonProps = {
  filter: GenericSearchFilter | 'all'
}

const HeaderSkeleton = () => {
  return (
    <div className="flex items-center justify-between">
      <div className="h-5 w-36 animate-pulse rounded bg-gray-200" />
      <div className="h-4 w-14 animate-pulse rounded bg-gray-200" />
    </div>
  )
}

const FilterBarSkeleton = () => {
  return (
    <div className="flex flex-row gap-2 overflow-x-auto">
      <div className="h-[32px] w-14 animate-pulse rounded-full bg-gray-200" />
      <div className="h-[32px] w-24 animate-pulse rounded-full bg-gray-200" />
      <div className="h-[32px] w-16 animate-pulse rounded-full bg-gray-200" />
    </div>
  )
}

const GenericSearchResultsViewSkeleton = ({ filter }: GenericSearchResultsViewSkeletonProps) => {
  const showBusiness = filter === 'all' || filter === 'businesses'
  const showUsers = filter === 'all' || filter === 'users'

  return (
    <div className="z-10 mt-2 flex flex-col gap-8">
      <FilterBarSkeleton />

      {showBusiness && (
        <div className="flex flex-col gap-6">
          <HeaderSkeleton />
          <div className="flex flex-col gap-4">
            {Array.from({ length: filter === 'all' ? 2 : 4 }).map((_, index) => (
              <FacelessBizSearchResultItemSkeleton key={`generic-business-skeleton-${index}`} />
            ))}
          </div>
        </div>
      )}

      {showUsers && (
        <div className="flex flex-col gap-6">
          <HeaderSkeleton />
          <div className="flex flex-col gap-0">
            {Array.from({ length: filter === 'all' ? 2 : 4 }).map((_, index) => (
              <UserSearchResultItemSkeleton key={`generic-user-skeleton-${index}`} />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default GenericSearchResultsViewSkeleton
